module.exports = __webpack_public_path__ + "static/media/insure_bg.92d61ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insure_bg.png
// module id = 2704
// module chunks = 2